import { collection, addDoc, Timestamp } from 'firebase/firestore';
import { db } from '../firebase/config';
import { COLLECTIONS } from '../firebase/collections';

export const createNotification = async (type, title, message, metadata = {}) => {
  try {
    await addDoc(collection(db, COLLECTIONS.NOTIFICATIONS), {
      type,
      title,
      message,
      metadata,
      read: false,
      createdAt: Timestamp.now()
    });
  } catch (error) {
    console.error('Error creating notification:', error);
  }
};

export const notifyNewOrder = async (orderData) => {
  await createNotification(
    'order',
    'طلب جديد',
    `طلب جديد من ${orderData.customerName} بقيمة $${orderData.total || 0}`,
    { orderId: orderData.id, customerName: orderData.customerName }
  );
};

export const notifyNewUser = async (userData) => {
  await createNotification(
    'user',
    'مستخدم جديد',
    `انضم ${userData.name} إلى الموقع`,
    { userId: userData.id, email: userData.email }
  );
};

export const notifyProductUpdate = async (productData, action = 'add') => {
  const actions = { add: 'إضافة', update: 'تعديل', delete: 'حذف' };
  await createNotification(
    'product',
    `${actions[action]} منتج`,
    `تم ${actions[action]} ${productData.name}`,
    { productId: productData.id, productName: productData.name }
  );
};

export const notifyOrderStatusChange = async (orderId, customerName, newStatus) => {
  const statusText = {
    pending: 'قيد الانتظار',
    processing: 'قيد المعالجة',
    completed: 'مكتمل',
    cancelled: 'ملغي'
  };

  await createNotification(
    'order',
    'تحديث حالة الطلب',
    `تم تغيير حالة طلب ${customerName} إلى ${statusText[newStatus]}`,
    { orderId, status: newStatus }
  );
};
